export default Object.freeze({
  OFFERED: 'OFF',
  ADMITTED: 'ADM',
  COMPLETED: 'COMP'
})
